export const publicRoutePaths = {
  storyAuthorizationSignature: '/historia/assinatura-autorizacao',
  storyAuthorizationValidation: '/historia/assinatura-validacao',
} as const;
